module.exports = __webpack_public_path__ + "static/media/lk.05b3389e.svg";